export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
export const telephoneRegex = /^(?:06|\+36|0036)\d{1,2}\d{3}\d{3,4}$/gm;